var _desc, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorybook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 30,
    viewBox: "0 0 2040 576",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "storybook-logo-final") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2 0 0 2 -4322 -506)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2161 253h1020v288H2161V253z",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "translate(2166 275)",
    fill: "#B57EE5"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "translate(2180 261)",
    fill: "#F1618C"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "translate(2326 261.5)",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2393 300)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    fill: "#6DABF5"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    fill: "#F3AD38"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    fill: "#B57EE6"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    fill: "#F16161"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    fill: "#B57EE5"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    fill: "#A2E05E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    transform: "translate(2220 301)",
    fill: "#FFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M21 246L9 0H0l9 246h12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M12 260L0 14 196 0v269l-184-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M0 35.5L2.5 2 26 0v35.5L14.182 24.81 0 35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M347.041 57.2h-32.78v18.26c0 23.54-.22 42.46-.22 42.46 0 11.66-4.84 14.74-11 14.74-6.38 0-9.68-2.86-9.68-15.18 0-18.04 1.32-53.68 1.32-53.68l-32.78-.88c0-.44-1.1 27.28-1.1 60.06s20.68 35.2 30.14 35.2c9.02 0 18.92-3.52 24.2-9.24 0 18.7-5.94 24.86-19.14 24.86-8.36 0-18.48-4.18-23.98-8.8v30.14c9.24 5.5 19.58 7.92 29.92 7.92 22 0 43.56-12.76 44-49.5.66-40.92.88-81.84 1.1-96.36zm165.55-.22c-33.44 0-47.74 26.84-47.74 58.74 0 27.06 13.2 47.3 44.66 47.3 35.2 0 47.74-26.4 47.74-56.98 0-28.38-12.32-49.06-44.66-49.06zm11.66 53.24c0 14.3-4.84 25.3-14.74 25.3-8.36 0-11.66-9.68-11.66-19.8 0-16.28 5.72-28.82 14.74-28.82 9.24 0 11.66 12.1 11.66 23.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M20.68 163.24c16.94.22 33.22-1.98 33.22-1.98 0-28.82 0-55.88.22-76.34 8.8-.88 16.06-1.98 16.06-1.98.44-13.86-.66-26.4-.66-26.4l-14.96.88c.44-20.9.88-31.68.88-31.68l-35.2 2.2s0 12.98.22 32.78c-10.78 1.32-18.7 3.52-18.7 3.52.44 11.66 4.62 24.2 4.62 24.2l14.3-.66v75.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M219.276 70.62c0-3.3.22-6.82.44-10.34l-30.58-1.1s-2.86 44.88-2.64 103.84c14.74 1.1 31.9 1.1 31.9 1.1-.22 0 0-19.58.88-49.06.44-17.16 6.6-22.44 15.84-22.44 5.5 0 12.32 2.42 12.32 2.42l3.52-30.58c-14.3-4.84-27.5-.66-31.68 6.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M396.026 162.58c0-4.84.44-9.24.44-11 3.74 5.5 11 10.34 20.02 10.34 25.3 0 36.3-24.86 36.96-54.34.44-27.94-10.12-51.26-33.44-51.26-8.58 0-15.84 4.62-19.8 9.46 1.98-32.78 3.52-53.68 3.52-53.68l-33.22-2.42c-1.98 22.88-5.06 98.56-4.62 153.78 19.14.44 30.14-.88 30.14-.88zm1.98-43.78c-.44-5.94-1.54-32.34 11.22-32.34 9.02 0 11.22 11 10.78 22-.22 11.88-2.64 25.3-11.88 25.3-6.38 0-9.46-4.62-10.12-14.96z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M776.409 64.24l-34.54-4.62s-11.88 17.82-28.6 38.28c2.64-46.86 5.94-78.32 5.94-78.32l-35.86-3.3s-3.96 81.4-4.84 146.08c14.96 1.76 32.34 1.76 32.34 1.76l1.1-38.72c16.28 18.48 34.54 37.62 34.54 37.62l38.06-6.16c-22-22-36.96-37.4-44.22-47.08 8.36-11.22 23.32-29.04 36.08-45.54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M126.088 56.98c-33.44 0-47.74 26.84-47.74 58.74 0 27.06 13.2 47.3 44.66 47.3 35.2 0 47.74-26.4 47.74-56.98 0-28.38-12.321-49.06-44.66-49.06zm11.66 53.24c0 14.3-4.841 25.3-14.74 25.3-8.36 0-11.66-9.68-11.66-19.8 0-16.28 5.719-28.82 14.74-28.82 9.24 0 11.66 12.1 11.66 23.32zM617.22 56.98c-33.44 0-47.74 26.84-47.74 58.74 0 27.06 13.2 47.3 44.66 47.3 35.2 0 47.74-26.4 47.74-56.98 0-28.38-12.32-49.06-44.66-49.06zm11.66 53.24c0 14.3-4.84 25.3-14.74 25.3-8.36 0-11.66-9.68-11.66-19.8 0-16.28 5.72-28.82 14.74-28.82 9.24 0 11.66 12.1 11.66 23.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M74.64 65.28l38.64-.96C114.24 26.88 94.8 8.4 60.96 8.4s-52.8 19.2-52.8 48c0 50.16 64.8 51.12 64.8 78.48 0 7.68-3.6 12.24-11.52 12.24-10.32 0-14.4-6.72-13.92-25.44H6.96c-3.12 46.32 24 56.88 54.96 56.88 30 0 53.52-13.92 53.52-44.16 0-53.76-65.76-52.32-65.76-78.96 0-10.8 7.68-12.24 12.24-12.24 4.8 0 13.44 1.92 12.72 22.08z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorybook);
export default __webpack_public_path__ + "static/media/storybook.15a2fcb164b1605c386f61a7d97a448c.svg";
export { ForwardRef as ReactComponent };